import { useNavigate } from 'react-router-dom';
import Breadcrumb from '@/components/common/Breadcrumb';
import CSVUpload from '@/components/common/CSVUpload';
import { useToast } from '@/components/common/Toast';
import { ParsedCSVData } from '@/types/upload';
import { validateMenuCsv } from '@/utils/menuCsvValidation';

const MenuUpload = () => {
  const navigate = useNavigate();
  const { showToast } = useToast();

  const handleUploadSuccess = (_data: ParsedCSVData) => {
    showToast('アップロードを受け付けました。処理状況はアップロード一覧で確認してください');
    navigate('/upload-management/new');
  };

  return (
    <div>
      <Breadcrumb />
      <div className="card max-w-6xl mx-auto">
        <h1 className="text-2xl font-bold text-admin-text mb-2">検索メニューCSVアップロード</h1>

        <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
          <h2 className="font-semibold text-admin-text mb-2">📋 CSVファイルのフォーマットと注意事項</h2>
          <ul className="text-sm text-admin-textLight space-y-1 list-disc list-inside">
            <li>ファイル形式：CSV形式（.csv）のみ</li>
            <li>ファイルサイズ：10MB以下</li>
            <li>文字コード：UTF-8（BOM 可）</li>
            <li>Book / Product と同じ 3 行構成：1 行目＝定義名 / 2 行目＝日本語表示名 / 3 行目以降＝データ</li>
            <li>1 ファイル = 1 メニューセット（MENU 行は 1 行のみ）</li>
            <li>列：data_type, menu_id, start_at, stop_at, title, link_to, link_to_target, view_type, platform</li>
            <li>data_type は MENU / BLOCK / ITEM（行順がそのまま表示順）</li>
            <li>title（BLOCK 見出し / ITEM 表示名）は任意・最大 25 文字</li>
            <li>menu_id=default は無期限（stop_at 空）、それ以外は stop_at 必須</li>
            <li>platform は 3 桁（web/ios/android, 1=表示/0=非表示。000 は不可）</li>
          </ul>
        </div>

        <CSVUpload
          uploadType="Menu"
          customValidate={validateMenuCsv}
          onUploadSuccess={handleUploadSuccess}
        />

        <div className="flex gap-4 mt-6">
          <button
            onClick={() => navigate('/upload-management/new')}
            className="px-6 py-2 border border-gray-300 text-admin-text rounded-lg hover:bg-gray-50 transition-colors"
          >
            戻る
          </button>
        </div>
      </div>
    </div>
  );
};

export default MenuUpload;
